<template>
    <!-- 竞猜 -->
    <div
        class="transpond_guess_content_new"
        @click.stop.prevent="hanleClickToPage"
    >
        <div class="transpond_title">
            <img alt :src="require('@/assets/images/icon_guessing.png')" />
            <div class="plate_img_text">趣味竞猜</div>
        </div>
        <div class="transpond_detail">
            <div class="guess_list">
                <h5 class="guess_title">{{ guess.title }}</h5>
                <p class="guess_num">奖金池 {{ guess.total_gold }}&nbsp;&nbsp;参与人数：{{ guess.total_num }}</p>
                <p class="guess_info">{{ guess.stock_guess_intro }}&nbsp;&nbsp;{{ guess.stock_guess_gold }}</p>
            </div>
            <div class="guess_btns">
                <div class="guess_btn">参与竞猜</div>
                <div class="guess_btn" v-if="guess.state != 'done'">跟单</div>
            </div>
        </div>
    </div>
</template>
<script>
import "@/utils/flexible";
export default {
    name: "guessCard",
    props: {
        guess: {
            type: Object,
            default: () => {
                return {}
            }
        },
        applicationPage: { // 来源使用页面 - 列表或者详情页【list,detail】
            type: String,
            default: "list"
        }
    },
    data() {
        return {

        }
    },
    methods: {
        hanleClickToPage() {
            // guess_page
            this.openNative('guess_page', {
                id: this.guess.id
            })
        },
        // 跳转APP页面
        openNative(type, query) {
            let params = {
                kind: type, // 类型
            };

            params = {
                ...params,
                ...query
            }

            switch(type) {
                case "guess_page": // 竞猜页面
                    break;
            }

            this.$srH5CallNativeMethodApp('call_Native',params)
        },
    }
}
</script>
<style scoped lang="scss">
@import "~@/assets/sass/global.scss";

.transpond_guess_content_new {
    height: 68px;
    padding: 0 8px 0 0;
    background: #F7F7F7;
    border-radius: 0;
    border: none;
    display: flex;
    box-sizing: border-box;

    .transpond_title {
        width: 68px;
        height: 68px;
        margin-right: 10px;
        position: relative;
        background: linear-gradient(180deg, #FF534B 0%, #EB342B 100%);

        >img {
            width: 100%;
            height: 100%;
        }

        .plate_img_text {
            position: absolute;
            width: 100%;
            bottom: 0;
            left: 0;
            color: #ffffff;
            font-size: 11px;
            line-height: 18px;
            text-align: center;
            height: 18px;
            background: #8C1E18;
        }
    }

    .transpond_detail {
        height: 100%;
        display: flex;
        justify-content: space-between;
        flex: 1;
        overflow: hidden;

        .guess_list {
            height: 100%;
            display: flex;
            flex-direction: column;
            justify-content: center;
            overflow: hidden;

            .guess_title {
                color: #222222;
                font-size: 14px;
                line-height: 20px;
                padding-right: 10px;
                white-space: nowrap;
                text-overflow: ellipsis;
                overflow: hidden;
            }

            .guess_num {
                font-size: 12px;
                line-height: 17px;
                color: #939393;
                margin-top: 6px;
            }

            .guess_info {
                font-size: 12px;
                line-height: 17px;
                color: #fe484a;
                margin-top: 0;
            }
        }

        .guess_btns {
            display: flex;
            flex-direction: column;
            height: 100%;
            justify-content: space-around;

            >div.guess_btn {
                width: 60px;
                height: 24px;
                background: #FE484A;
                border-radius: 2px;
                color: #ffffff;
                text-align: center;
                font-size: 12px;
                line-height: 24px;
            }
        }
    }
}
</style>